module.exports = __webpack_public_path__ + "files/522222f3a1a756cebfdb4980b0815dc2.png";